import {
  applyEndpointPathParams,
  extractEndpointPathParamKeys,
} from '@packages/table-builder/utils/remoteDataHelpers';

type DataSourceLike = {
  endpoint?: string;
  requestParams?: Record<string, string>;
};

type SchemaLike = {
  dataSource?: DataSourceLike;
};

/**
 * When embedded-table filters supply path params (e.g. `{ Id }`), bake them into
 * `dataSource.endpoint` so list GETs hit `/.../uuid` instead of `/.../{Id}?Id=uuid`.
 */
export function bakeEmbeddedTableEndpoint<T extends SchemaLike>(
  schema: T,
  filter: Record<string, unknown> | undefined,
): T {
  const ds = schema.dataSource;
  const endpoint = ds?.endpoint;
  if (!endpoint?.includes('{') || filter == null) {
    return schema;
  }

  const pathParams: Record<string, unknown> = {};
  for (const key of extractEndpointPathParamKeys(endpoint)) {
    const value = filter[key];
    if (value != null && value !== '') {
      pathParams[key] = value;
    }
  }
  if (Object.keys(pathParams).length === 0) {
    return schema;
  }

  const bakedEndpoint = applyEndpointPathParams(endpoint, pathParams);
  if (bakedEndpoint.includes('{')) {
    return schema;
  }

  const requestParams = { ...(ds?.requestParams ?? {}) };
  for (const key of Object.keys(pathParams)) {
    delete requestParams[key];
  }

  return {
    ...schema,
    dataSource: {
      ...ds,
      endpoint: bakedEndpoint,
      requestParams,
    },
  };
}
